// extracted by mini-css-extract-plugin
module.exports = {"customLink":"NiceLink_customLink__3P72P"};